module.exports = __webpack_public_path__ + "img/soderberg.ddecffc1.png";